import { useEffect, useState } from "react";
import { apmKeyApplePayKey, apmKeys } from "../../constants/common.c";
import { applePayController } from "../apple-pay-button/components/apple-pay";

/**
 * A wallet button renders full width unless the only other enabled APM is
 * Apple Pay with an active Apple Pay session (then the two share a row).
 */
export const useFullWidthWalletButton = (apiData: any, componentKey: string) => {
  const [isFullWidthButton, setIsFullWidthButton] = useState(true);

  useEffect(() => {
    const applicableKeys = apmKeys.filter(
      (key) => key !== componentKey && apiData[key]
    );
    if (applicableKeys.length > 0) {
      setIsFullWidthButton(
        !(
          applicableKeys.length === 1 &&
          applicableKeys.includes(apmKeyApplePayKey) &&
          applePayController.isAppleSessionAvailable()
        )
      );
    }
  }, [apiData, componentKey]);

  return isFullWidthButton;
};
